<template>
  <div>
    <header class="head">
      <h1 class="logo">
        <img
          v-if="!isLogin"
          src="../assets/img/common/logo_nd.png"
          alt="ND-net"
        />
      </h1>
      <div class="logo_nitto">
        <head-menu v-if="!isLogin && !isError"></head-menu>

        <img src="../assets/img/common/logo_nitto.png" alt="" />
      </div>
    </header>

    <privacy v-if="!isLogin && !isError" />
  </div>
</template>

<script>
export default {
  props: {
    isLogin: { type: Boolean, default: false },
    isError: { type: Boolean, default: false }
  }
};
</script>
